import React from 'react';
import { Box, BoxProps, FuseSelect, dataModelIcons } from '/src/components';
import { Asset, TAssetId } from '/src/lib/models';
import { DataModelType } from '/src/lib/types';

export type AssetSelectProps = {
  /**
   * Selected Asset ID
   */
  value: TAssetId;
  /**
   * Sets the currently selected Asset ID
   * @param value TAssetId
   * @returns void
   */
  setValue: (value: TAssetId) => void;
  /**
   * List of Assets to display in the dropdown
   */
  assets: Asset[];
  /**
   * Optional Box component props
   */
  boxProps?: BoxProps;
  /**
   * Show a label for this component
   */
  showLabel?: boolean;
  /**
   * Element ID
   */
  id?: string;
  /**
   * Element name
   */
  name?: string;
  /**
   * Element class
   */
  className?: string;
  /**
   * Whether this component is disabled
   */
  disabled?: boolean;
  /**
   * If true, shows error if value is empty
   */
  required?: boolean;
  /**
   * Error to display if `required` is set to true
   */
  error?: string;
};

export const AssetSelect: React.FC<AssetSelectProps> = ({ value, setValue, assets, boxProps, ...selectProps }) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" gap="6px" {...boxProps}>
      <Box component="span">{dataModelIcons[DataModelType.Asset]}</Box>
      <FuseSelect
        value={value}
        updateValue={(value) => setValue(value)}
        placeholder="Select Asset"
        ariaLabel="Select Asset"
        options={assets.map((asset) => ({ label: asset.name, value: asset._id }))}
        {...selectProps}
      />
    </Box>
  );
};
